import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { routes } from './Routes';
import AppLayout from '../Layout/Layout';
import { hasRole } from '../utils/auth';

const LayoutRoutes = () => {
  return (
    <Routes>
      {routes.map(({ path, Component, roles }, i) => (
        <Route key={i} element={<AppLayout />}>
          <Route
            path={path}
            element={
              !roles || hasRole(...roles)
                ? Component
                : <Navigate
                    to={`${process.env.PUBLIC_URL}/err403`}
                    replace
                  />
            }
          />
        </Route>
      ))}
    </Routes>
  );
};

export default LayoutRoutes;